<mat-checkbox
  (change)="toggleEnhancedPointCloud()"
  [ngModel]="settingsStore('enhancedCloudSettings')('enabled').$ | async"
>
  <div class="checkbox-content">Enable Enhanced Point Cloud</div>
</mat-checkbox>

@if (enhancedCloudStore('enabled').$ | async) {
  <h3-objectless-view-settings-slider
    *h3Injector="fusionManager.getPrimaryMinion().injector"
    [min]="1"
    [max]="maxFrameCount$ | async"
    [default]="defaultFrameCount$ | async"
    [nasModel]="enhancedCloudStore('frames')"
    [settingStore]="enhancedCloudStore('frames')"
    suffix=" Frames"
    label="Number of frames accumulated"
  ></h3-objectless-view-settings-slider>
}

<mat-expansion-panel
  class="advanced-settings enhanced-point-cloud"
  *ngIf="enhancedCloudStore('enabled').$ | async"
>
  <mat-expansion-panel-header class="advanced-settings-content">
    <mat-panel-title class="advanced-header-settings"
      >Advanced Settings</mat-panel-title
    >
  </mat-expansion-panel-header>
  <div class="enhanced-settings-spacing">
    <h3-objectless-view-settings-slider
      *h3Injector="fusionManager.getPrimaryMinion().injector"
      [min]="0"
      [max]="100"
      [default]="defaultEnhancedPointDensity"
      [nasModel]="enhancedCloudStore('density')"
      [settingStore]="enhancedCloudStore('density')"
      label="Point cloud density"
    ></h3-objectless-view-settings-slider>

    <span>Frames accumulated</span>
    <h3-toggle-button-group
      [nasModel]="enhancedCloudStore('direction')"
      [buttons]="directionButtons"
      [fillArea]="true"
    >
    </h3-toggle-button-group>
  </div>
</mat-expansion-panel>
